module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "all",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "info",
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    staticClass: "up-area",
    attrs: {
      "src": require("../assets/icon/semi.png"),
      "alt": "L"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-area"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/icon/logo1.png"),
      "alt": "L"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "title",
    attrs: {
      "src": require("../assets/icon/title.png"),
      "alt": "T"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "subtitle",
    attrs: {
      "src": require("../assets/icon/subtitle.png"),
      "alt": "S"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "down-area",
    attrs: {
      "src": require("../assets/icon/semi.png"),
      "alt": "L"
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("歡迎登入 SGroup E-learning")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "帳號（工號）"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": _vm.showPass ? 'text' : 'password',
      "auto-complete": "off",
      "placeholder": "密碼"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleSubmit2($event)
      }
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "20px",
      "height": "20px",
      "right": "1rem",
      "top": "0.5rem",
      "cursor": "pointer"
    },
    attrs: {
      "title": _vm.showPass ? '顯示密碼' : '隱藏密碼',
      "src": _vm.showPass ? _vm.openeye : _vm.nopeneye
    },
    on: {
      "click": function($event) {
        _vm.showPass = !_vm.showPass
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "12px"
    }
  }, [_c('div', {
    staticClass: "txtBtn",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.forgetPwd
    }
  }, [_vm._v("忘記密碼")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "12px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登入\n            ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "txtBtn",
    staticStyle: {
      "float": "left"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("沒有帳號？馬上註冊！")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v("有無法解決的難題？請聯繫管理員\n            "), _c('div', {
    staticClass: "contact-admin"
  }, [_vm._v("曾德恩 Jeffrey Tseng \n              "), _c('a', {
    staticStyle: {
      "margin-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "href": "mailto:jeffrey.te.tseng@foxconn.com"
    }
  }, [_vm._v("jeffrey.te.tseng@foxconn.com\n              ")])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a361cee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 917
// module chunks = 170